import {
  Card,
  Timeline,
  Avatar,
  List,
  Button,
  Typography,
  Menu,
  Icon,
  Form,
  Dropdown,
  Tooltip,
  Comment,
  Popconfirm,
} from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { Constants } from "../../data/constants";
import "./viewTicketDetails.css";
import userAvatar from "../../resource/user.jpg";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import "moment/locale/ar";

import { showSuccessToast } from "../general/ToastHelper";
import {
  ClockCircleOutlined,
  EditOutlined,
  UserOutlined,
  CheckCircleOutlined,
  HighlightOutlined,
  UndoOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  convertTZToLocal,
  convertTZToLocalFormat,
} from "../general/DateTzHelper";
import { TicketService } from "../../services/Ticket/TicketService";
import { handleError } from "../../utils/ErrorHandlers";
import { UserService } from "../../services/user/UserService";
import { FileService } from "../../services/file/FileService";
import i18next from "i18next";
import CommentParagraph from "../../utils/CommentParagraph";
const { Meta } = Card;
const { Text, Paragraph } = Typography;
class Comments extends Component {
  constructor(props) {
    super(props);

    this.props.context.setCurrentComponent("viewTicketDetails");
    this.constants = new Constants();
    this.ticketService = new TicketService();
    this.userService = new UserService();
    this.fileService = new FileService();
    this.state = {
      ticket: {},
      isFetching: false,
      formLayout: "inline",
      editLoading: false,
      editMode: false,
      imagePreviewUrl: "",
      comment: "",
      commentList: this.props.commentList,
      trackingList: this.props.commentList.trackingList,
      action: null,
      lang:
        this.props.context.curr_lang === "ar" &&
        this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
    };
  }

  async componentDidMount() {
    let response = await this.getUserImg();
    this.setState({ imagePreviewUrl: response });
  }
  async getUserImg() {
    let session_id = this.props.context.session_id;
    let user_id = this.state.commentList.userId;
    try {
      return await this.fileService.getUserImg(session_id, user_id);
    } catch (e) {
      return userAvatar;
    }
  }

  getTextAreaInput = (e) => {
    this.setState({
      comment: e.target.value,
    });
    e.target.value = "";
  };
  editComment = async () => {
    this.setState({ editLoading: true });
    let value = this.state.comment;
    let comment = {
      content: value,
      id: this.state.commentList.id,
    };
    let { commentList } = this.state;
    try {
      let data = await this.ticketService.editComment(
        this.props.context.session_id,
        comment
      );
      if (data.statusMsg === "success") {
        commentList.content = value;
        this.setState({
          commentList,
          editLoading: false,
          editMode: false,
        });
      }
    } catch (e) {
      this.setState({ editLoading: false,editMode:false });

      this.setState();
      handleError(e);
    }
  };

  cancelComment = () => {
    this.setState({
      editMode: false,
    });
  };

  deleteComment = async () => {
    this.setState({ deleteLoading: true });

    try {
      let data = await this.ticketService.deleteComment(
        this.props.context.session_id,
        this.state.commentList.id
      );

      this.setState({ deleteLoading: false });
      showSuccessToast(i18next.t(" Comment deleted successfully"));
      window.location.reload();
    } catch (e) {
      this.setState({ deleteLoading: false });
      handleError(e);
    }
  };

  iconList = (icon) => {
    switch (icon) {
      case "close":
        return <CheckCircleOutlined />;
      case "dueDate":
        return <ClockCircleOutlined />;

      case "reOpen":
        return <UndoOutlined />;
      case "assign":
        return <UserOutlined />;
      case "subject":
        return <HighlightOutlined />;
      default:
        return <EditOutlined />;
    }
  };
  timeLineList = () => {
    return (
      <List
        dataSource={this.state.trackingList}
        renderItem={(item) => {
          return (
            <Timeline.Item
              dot={this.iconList(item.changeType)}
              style={{ fontSize: "16px", borderLeft: " #996464" }}
            >
              {item.trackingObject.userName}{" "}
              {i18next.t(item.trackingObject.action)}{" "}
              {item.changeType != "close" && item.changeType != "reOpen"
                ? i18next.t(item.trackingObject.prevState) +
                  i18next.t(" to ") +
                  i18next.t(item.trackingObject.currState)
                : ""}{" "}
              <Tooltip
                title={moment(item.createdOn)
                  .locale(this.state.lang)
                  .format("YYYY-MM-DD HH:mm:ss")}
              >
                <span>
                  {moment(item.createdOn).locale(this.state.lang).fromNow()}
                </span>
              </Tooltip>
            </Timeline.Item>
          );
        }}
      />
    );
  };
  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item
          onClick={() => {
            this.setState({ editMode: true });
          }}
        >
          <span>{i18next.t("Edit")}</span>
          <Icon className={"view-details-style"} type="edit" />
        </Menu.Item>
        <Menu.Item>
          <Popconfirm
            title={i18next.t("Are you sure delete this Comment?")}
            onConfirm={() => this.deleteComment()}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <div>
              <span>{i18next.t("Delete")}</span>
              <Icon className={"delete-account-style"} type="delete" />
            </div>
          </Popconfirm>
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }
  // actions = [
  //   <span key="comment-basic-like">
  //     <Tooltip title="edit">
  //       <Icon
  //         type="edit"
  //         //theme={action === "liked" ? "filled" : "outlined"}
  //         onClick={this.setState({ editMode: true })}
  //       />
  //     </Tooltip>
  //   </span>,
  //   <span key=' key="comment-basic-dislike"'>
  //     <Tooltip title="delete">
  //       <Icon
  //         type="delete"
  //         //theme={action === "disliked" ? "filled" : "outlined"}
  //         onClick={this.deleteComment}
  //       />
  //     </Tooltip>
  //   </span>,
  //   //<span key="comment-basic-reply-to">Reply to</span>,
  // ];
  render() {
    let { commentList, imagePreviewUrl } = this.state;
    return (
      <div>
        <Card
          size="small"
          bordered={true}
          className="card"
          style={{
            marginTop: "20px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            padding: "10px",
          }}
          extra={ this.props.context.user.userId == commentList.userId || this.props.context.user.userType == "ADMIN" ? this.renderActionDropdown(commentList.id):""}
          title=<div>
            <Avatar
              icon={<UserOutlined />}
              src={imagePreviewUrl}
              style={{ marginRight: "10px" }}
            />
            <Text strong>{commentList.createdBy}</Text>
            <Text type="secondary" style={{ fontSize: "small" }}>
              {" "}
              {i18next.t("commented")}{" "}
              <Tooltip
                title={moment(commentList.createdOn)
                  .locale(this.state.lang)
                  .format("YYYY-MM-DD HH:mm:ss")}
              >
                <span>
                  {moment(commentList.createdOn)
                    .locale(this.state.lang)
                    .fromNow()}
                </span>
              </Tooltip>
            </Text>
          </div>
        >
          {this.state.editMode ? (
            <div style={{ marginTop: "10px" }}>
              <Form.Item>
                <TextArea
                  rows={4}
                  maxLength={250}
                  defaultValue={commentList.content}
                  onChange={(value) => this.getTextAreaInput(value)}
                  placeholder={i18next.t("Please Enter Your Comment")}
                ></TextArea>
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  xs: { span: 24, offset: 0 },
                  sm: { span: 16, offset: 8 },
                }}
              >
                <Button
                  className="button-submit"
                  type="primary"
                  onClick={this.editComment}
                  size={"small"}
                  loading={this.state.editLoading}
                >
                  {i18next.t("Edit")}
                </Button>
                <Button
                  className="button-submit"
                  type="primary"
                  onClick={this.cancelComment}
                  size={"small"}
                >
                  {i18next.t("Cancel")}
                </Button>
              </Form.Item>
            </div>
          ) : (
            // <Co>{commentList.content}</Paragraph>
            <CommentParagraph content={commentList.content}></CommentParagraph>
          )}
        </Card>

        {/* <Comment
          actions={this.actions}
          author={<Text strong>{commentList.createdBy}</Text>}
          avatar={
            <Avatar
              icon={<UserOutlined />}
              src={imagePreviewUrl}
              // style={{ marginRight: "10px" }}
            />
          }
          // style={{ backgroundColor: "grey" }}
          content={
            this.state.editMode ? (
              <div style={{ marginTop: "10px" }}>
                <Form.Item>
                  <TextArea
                    rows={4}
                    maxLength={250}
                    defaultValue={commentList.content}
                    onChange={(value) => this.getTextAreaInput(value)}
                    placeholder="Please Enter Your Comment"
                  ></TextArea>
                </Form.Item>
                <Form.Item
                  wrapperCol={{
                    xs: { span: 24, offset: 0 },
                    sm: { span: 16, offset: 8 },
                  }}
                >
                  <Button
                    className="button-submit"
                    type="primary"
                    onClick={this.editComment}
                    size={"small"}
                    loading={this.state.editLoading}
                  >
                    Edit
                  </Button>
                </Form.Item>
              </div>
            ) : (
              <Paragraph>{commentList.content}</Paragraph>
            )
          }
          datetime={
            <Tooltip
              title={moment(commentList.createdOn).format(
                "YYYY-MM-DD HH:mm:ss"
              )}
            >
              <span>{moment(commentList.createdOn).fromNow()}</span>
            </Tooltip>
          }
        /> */}

        <Timeline
          style={{
            paddingLeft: "70px",
            paddingTop: "10px",
            display:
              Object.keys(this.state.trackingList).length !== 0
                ? "block"
                : "none",
          }}
        >
          {this.timeLineList()}
        </Timeline>
      </div>
    );
  }
}

export default withSharedStateConsumer(withRouter(Comments));
